<div class="input-group">
    <input class="form-control select-custom" placeholder="{{ placeholder }}" autocomplete="off" type="text"
        id="searchInput1" [(ngModel)]="query" name="query" (keyup.enter)="activateModal()" minlength="3" maxlength="40"
        pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]+$" #queryInput="ngModel">
    <div class="input-group-append">
        <button class="search-button" #modalButton data-bs-toggle="modal" data-bs-target="#results-search"
            (click)="search()">
            <i class="fa fa-search" style="color: aliceblue;"></i>
        </button>
    </div>
</div>
<div class="row">
    <div class="col">
        <div *ngIf="queryInput.errors?.pattern" class="error-message">
            El campo contiene caracteres no permitidos.
        </div>
    </div>
</div>



<!-- Modal -->
<div class="modal fade" id="results-search" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true" [ngClass]="{'show': showModal}">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">

                <div class="col-sm-8">
                    <div class="input-group">
                        <input #searchInput class="form-control select-custom" placeholder="Buscar" autocomplete="off"
                            type="text" id="searchInput2" [(ngModel)]="query" name="query" (keyup.enter)="search()"
                            pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]+$">
                        <div class="input-group-append">
                            <button class="search-button" (click)="search()">
                                <i class="fa fa-search" style="color: aliceblue;"></i>
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div *ngIf="queryInput.errors?.pattern" class="error-message">
                                El campo contiene caracteres no permitidos.
                            </div>
                        </div>
                    </div>
                </div>
                <a type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></a>
            </div>
            <div class="modal-body">
                <br>

                <div class="col-sm-12">
                    <span class="result__found" *ngIf="searchResults.length > 1">
                        Se encontraron <b>{{searchResults.length}} publicaciones</b>
                    </span>
                    <span class="result__found" *ngIf="searchResults.length === 1">
                        Se encontró <b>{{searchResults.length}} publicación</b>
                    </span>
                </div>

                <!-- Resultados de búsqueda -->
                <ng-template [ngIf]="searchResults.length < 1" [ngIfElse]="show">
                    <div class="jumbotron jumbotron-fluid">
                        <div class="container">
                            <h1 class="display-4">CEPLAN</h1>
                            <p class="lead">No se encontraron coincidencias para la búsqueda realizada.
                            </p>
                        </div>
                    </div>
                </ng-template>

                <ng-template #show>
                    <ng-container
                        *ngFor="let item of searchResults| paginate:{itemsPerPage:10, currentPage:pages}; let i = index">
                        <!-- Mostrar aquí los detalles de cada resultado -->
                        <div class="col-sm-12" *ngIf="item">

                            <article class="excerpt">
                                <header class="excerpt__header">
                                    <div class="excerpt__title">
                                        <a class="underline" [routerLink]="['../ficha/'+ item.code]" target="_blank">
                                            {{item.longtitle}}
                                        </a>
                                    </div>
                                    <div class="post__meta">
                                        <em *ngIf="item.lastUpdated">{{ item.lastUpdated|date}}</em>
                                        <em *ngIf="!item.lastUpdated">{{ item.publication|date}}</em>
                                        <em>{{item.title}}</em>
                                        <ng-container *ngIf="dptoList.length > 0">
                                            <em *ngIf="getDptoName(item.iddpto)">{{
                                                getDptoName(item.iddpto) }}</em>
                                        </ng-container>
                                        <ng-container *ngIf="sectorList.length > 0">
                                            <em *ngIf="getSectorName(item.idsector)">Sector: {{
                                                getSectorName(item.idsector)}}</em>
                                        </ng-container>

                                    </div>
                                </header>
                                <div class="excerpt__body">
                                    <p [innerHTML]="item.summary| highlightsmodal:(highlights ? highlights : '')"></p>
                                </div>
                                <hr class="final__line">
                            </article>
                        </div>

                    </ng-container>
                    <div class="text-center">
                        <pagination-controls (pageChange)="pages = $event" previousLabel="Anterior"
                            nextLabel="Siguiente">
                        </pagination-controls>
                    </div>
                </ng-template>

            </div>
        </div>
    </div>
</div>